export const name = 'QaAspect'

export function init({}, {initialData: {windowObject, isQAMode, qaAPI}}) {
    if (windowObject && isQAMode) {
        windowObject.qaApi = qaAPI
    }
}
